import React, { useEffect, useState } from "react";
import "./MainLayout.css";
import Navbar from "./components/SideBar";
import Header from "./components/Header";
import { Outlet } from "react-router-dom";
import ContactButton from "./components/ContactButton";
import BottomNavbar from "./components/ButtomNavbar";
import { SidebarLayoutProvider, useSidebarLayout } from "../../contexts/SidebarLayoutContext";

/** Inner desktop layout — reads sidebar state from context */
const DesktopLayout = () => {
  const { isSidebarOpen, toggleSidebar } = useSidebarLayout();
  return (
    <div className="h-screen flex flex-col bg-[#f8f9fd] overflow-hidden">
      <Header />

      <div className="flex flex-1 min-h-0 min-w-0">
        <Navbar
          isOpen={isSidebarOpen}
          toggleSidebar={toggleSidebar}
        />

        <main className="flex-1 min-w-0 min-h-0 flex flex-col overflow-hidden">
          <div className="flex-1 min-h-0 min-w-0 overflow-y-auto p-4 sm:p-8">
            <Outlet />
          </div>

          <ContactButton />
        </main>
      </div>
    </div>
  );
};

const MainLayout = ({ isMobile }) => {
  const [viewportHeight, setViewportHeight] = useState(
    isMobile ? window.innerHeight : "100%"
  );

  useEffect(() => {
    if (!isMobile) return;
    const updateHeight = () => setViewportHeight(window.innerHeight);
    updateHeight();
    window.addEventListener("resize", updateHeight);
    return () => window.removeEventListener("resize", updateHeight);
  }, [isMobile]);

  /* ================= MOBILE ================= */
  if (isMobile) {
    return (
      <div
        className="relative w-full bg-[#f8f9fd] overflow-hidden"
        style={{ height: `${viewportHeight}px` }}
      >
        <div className="absolute inset-0 overflow-y-auto pb-[calc(88px+env(safe-area-inset-bottom))]">
          <Outlet />
        </div>
        <BottomNavbar />
      </div>
    );
  }

  /* ================= DESKTOP ================= */
  return (
    <SidebarLayoutProvider hasSidebar={true}>
      <DesktopLayout />
    </SidebarLayoutProvider>
  );
};

export default MainLayout;
